import { render } from "./About.vue?vue&type=template&id=59b2df00"
const script = {}
script.render = render

export default script